import { useCallback } from 'react';

import styled from '@emotion/styled';
import { useConnectModal } from '@rainbow-me/rainbowkit';
import { disconnect } from '@wagmi/core';
import { NamespaceKeys, useTranslations } from 'next-intl';

import { Button, showSnackbar } from '@web/ui/components';
import { ConnectWalletRainbowKitProvider } from '@web/utils/rainbowkit/RainbowKitProvider';
import { wagmiConfig } from '@web/utils/rainbowkit/WagmiProvider';

const Container = styled.div`
  width: 100%;
  > div[data-rk] {
    width: 100%;
  }
`;

const _ConnectWallet = () => {
  const t = useTranslations();
  const { openConnectModal } = useConnectModal();
  const handleClick = useCallback(async () => {
    await disconnect(wagmiConfig);
    openConnectModal?.();
  }, []);

  return (
    <Button
      label={t('SETTINGS_PAGE_ACTION_CONNECT_WALLET')}
      onClick={handleClick}
      fullWidth
    />
  );
};

export const ConnectWallet = () => {
  const t = useTranslations();

  const handleSuccess = useCallback(() => {
    showSnackbar(t('SETTINGS_CONNECT_WALLET_SUCCESS'));
  }, [t]);

  const handleError = useCallback(
    (err: unknown) => {
      if (!(err instanceof Error)) return;

      let readableError = t(
        `SETTINGS_CONNECT_WALLET_${err.message}` as NamespaceKeys<
          string,
          string
        >,
      );
      if (readableError === `TWITTER_ERROR_${err.message}`) {
        readableError = t('SETTINGS_CONNECT_WALLET_UNKNOWN', {
          error: err.message,
        });
      }

      showSnackbar(readableError, { severity: 'error' });
    },
    [t],
  );

  return (
    <Container>
      <ConnectWalletRainbowKitProvider
        onSuccess={handleSuccess}
        onError={handleError}
      >
        <_ConnectWallet />
      </ConnectWalletRainbowKitProvider>
    </Container>
  );
};
